import { render, staticRenderFns } from "./newBillOverseasSCenterView.vue?vue&type=template&id=03bd6317&"
import script from "./newBillOverseasSCenterView.vue?vue&type=script&lang=js&"
export * from "./newBillOverseasSCenterView.vue?vue&type=script&lang=js&"
import style0 from "./newBillOverseasSCenterView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03bd6317')) {
      api.createRecord('03bd6317', component.options)
    } else {
      api.reload('03bd6317', component.options)
    }
    module.hot.accept("./newBillOverseasSCenterView.vue?vue&type=template&id=03bd6317&", function () {
      api.rerender('03bd6317', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/BillOverseasSCenter/components/view/newBillOverseasSCenterView.vue"
export default component.exports